import React from 'react';
import education from "../images/education.svg";

function Education() {
    return (

        <div className="container">
            <header>
                <h1 className="title has-text-centered has-text-white">Education</h1>
            </header>

            <div className="columns is-centered">
                <div className="card column is-one-quarter">
                    <div className="card-image has-text-centered">
                        <figure className="image is-128x128 is-inline-block">
                            <img src={education} className="is-rounded clip-circle" alt="" />
                        </figure>
                    </div>
                    <div className="card-content">
                        <h2 className="subtitle">University of Oulu</h2>
                        <h3>Major</h3>
                        <p>
                            Master of Arts in English
                        </p>
                        <h3>Minor</h3>
                        <p>
                            Information Studies<br />
                            History of Ideas
                        </p>
                        <h2 className="subtitle">College</h2>
                        <p>
                            Posio College
                        </p>
                        <h2 className="subtitle">Primary school</h2>
                        <p>
                            Various primary schools in Posio
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Education;